import type { CouponBoardIdentifiers } from '../../../../schema/coupon/entry.js';
import { getInstanceClient } from '../../../di/entry.browser.js';
import { type CouponBoardPayload, PoolbettingError } from '../../../domain/entry.js';
import type { ActionResult } from '../../../lib/entry.js';

type UpdateBetAmountArgs = CouponBoardIdentifiers;

/**
 * Updates a given coupon bet amount.
 *
 * @param payload Object containing new coupon values
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order to update board for
 * @param root0.boardIndex Unique id of the board
 * @returns SUCCESS if successful, otherwise ERROR
 */
export async function updateCouponBoard(
  payload: CouponBoardPayload,
  { couponId, couponIndex, boardIndex }: UpdateBetAmountArgs
): Promise<ActionResult<boolean>> {
  const updateCouponBoardController = getInstanceClient('IUpdateCouponBoardController');

  try {
    const response = await updateCouponBoardController(payload, { couponId, couponIndex, boardIndex });
    const isUpdated = response > 0;

    if (!isUpdated) {
      return { status: 'ERROR', error: 'Det gick inte att uppdatera' };
    }

    return { status: 'SUCCESS', data: isUpdated };
  } catch (error) {
    if (PoolbettingError.isInstance(error)) {
      return error.toActionResult();
    }

    return { status: 'ERROR', error: 'Det gick inte att uppdatera' };
  }
}
